import index from "./Home"
export default index;